// extracted by mini-css-extract-plugin
export default {"share":"Share_share__peTlS","share-logo":"Share_share-logo__tEKEZ"};